"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$transitions, _theme$transitions$ea, _theme$transitions2, _theme$transitions2$d;
  return {
    arrow: {
      cursor: "pointer",
      display: "block",
      position: "absolute",
      top: "50%",
      transition: theme.transitions.create("all", {
        easing: (_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 ? void 0 : (_theme$transitions$ea = _theme$transitions.easing) === null || _theme$transitions$ea === void 0 ? void 0 : _theme$transitions$ea.easeInOut,
        duration: (_theme$transitions2 = theme.transitions) === null || _theme$transitions2 === void 0 ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) === null || _theme$transitions2$d === void 0 ? void 0 : _theme$transitions2$d.complex
      }),
      zIndex: 4,
      "& svg path": {
        fill: "#FFFFFF"
      }
    },
    arrowDisabled: {
      display: "none"
    },
    arrowPrev: {
      left: theme.spacing(3),
      transform: "translate(0, -50%)"
    },
    arrowNext: {
      right: theme.spacing(3),
      transform: "translate(0, -50%)"
    }
  };
});
var _default = styles;
exports.default = _default;